import Button from '@/common/components/Button'
import { CopyButton } from '@/common/components/CopyButton'
import Modal from '@/common/components/Modal'
import ResumeItem from '@/common/components/ResumeItem'
import { useCopyButton } from '@/common/hooks/useCopyButton'
import { useForwardingTabContext } from '@/features/maintenanceWorkflow/pages/Show/hooks/forwardings/useForwardingTabContext'
import { SignpostIcon } from 'lucide-react'
import { useState } from 'react'

const CheckoutDeliveryCode = () => {
  const { forwarding } = useForwardingTabContext()

  const [isOpen, setIsOpen] = useState(false)

  const { control: controlCopy, copySuccess } = useCopyButton()

  const handleCopy = () => {
    copySuccess(forwarding?.checkout_entry?.delivery_code || '')
  }

  return (
    <Modal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      Trigger={
        <Button>
          <SignpostIcon size={20} />
          Código de Check-Out
        </Button>
      }
      title="Código de Check-Out"
      titleClass="text-2xl"
      bodyClassName="text-white-800"
      body={
        <ResumeItem
          label="Código para Check-Out"
          value={
            forwarding?.checkout_entry?.delivery_code ? (
              <div className="flex items-center gap-1.5">
                <p>{forwarding?.checkout_entry?.delivery_code}</p>

                <CopyButton
                  control={controlCopy}
                  onClick={handleCopy}
                  className="text-blue-800 size-4"
                />
              </div>
            ) : (
              '--'
            )
          }
        />
      }
    />
  )
}

export default CheckoutDeliveryCode
